import { FC } from 'react';
import { Image } from 'src/general/components/Image/Image';
import { formatNumber } from 'src/general/helpers/formatNumber';
import { IconCircleCheckOuterBorder } from 'src/general/Icons/IconCircleCheckOuterBorder';
import styles from './GetStartedCarTile.module.scss';

type Props = {
  model: string;
  variant: string;
  imageUrl: string;
  kilometers: number;
};

const GetStartedCarDetails: FC<Props> = ({ imageUrl, variant, model, kilometers }: Props) => {
  return (
    <div className={styles.carDetails}>
      <div className={styles.imageContainer}>
        <Image src={imageUrl} alt="Car Image" width={620} height={400} className={styles.carImage} />
        <IconCircleCheckOuterBorder className={styles.iconGreenTick} />
      </div>
      <h6 className={styles.carName}>{model}</h6>
      <div className={styles.carInfoContainer}>
        <ul className={styles.carInfo}>
          <li className={styles.carInfoItem}>{variant}</li>
          <li className={styles.carInfoItem}>{formatNumber(kilometers, { append: ' km' })}</li>
        </ul>
      </div>
    </div>
  );
};

export default GetStartedCarDetails;
